import script from "./AssessmentStaffSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentStaffSummary.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentStaffSummary.vue?vue&type=style&index=0&id=40981a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40981a4e"]])

export default __exports__